/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_State_Coming_SoonInputs */

const en_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`coming soon`)
};

const ar_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قريباً`)
};

const de_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demnächst`)
};

const es_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximamente`)
};

const fr_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bientôt`)
};

const it_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimamente`)
};

const ja_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まもなく開始`)
};

const ko_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`곧 시작됩니다`)
};

const pt_br_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em breve`)
};

const ru_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скоро`)
};

const th_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เร็ว ๆ นี้`)
};

const tr_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yakında`)
};

const zh_cn_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即将开始`)
};

const zh_tw_event_state_coming_soon = /** @type {(inputs: Event_State_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即將開始`)
};

/**
* | output |
* | --- |
* | "coming soon" |
*
* @param {Event_State_Coming_SoonInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_state_coming_soon = /** @type {((inputs?: Event_State_Coming_SoonInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_State_Coming_SoonInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_state_coming_soon(inputs)
	if (locale === "ar") return ar_event_state_coming_soon(inputs)
	if (locale === "de") return de_event_state_coming_soon(inputs)
	if (locale === "es") return es_event_state_coming_soon(inputs)
	if (locale === "fr") return fr_event_state_coming_soon(inputs)
	if (locale === "it") return it_event_state_coming_soon(inputs)
	if (locale === "ja") return ja_event_state_coming_soon(inputs)
	if (locale === "ko") return ko_event_state_coming_soon(inputs)
	if (locale === "pt_br") return pt_br_event_state_coming_soon(inputs)
	if (locale === "ru") return ru_event_state_coming_soon(inputs)
	if (locale === "th") return th_event_state_coming_soon(inputs)
	if (locale === "tr") return tr_event_state_coming_soon(inputs)
	if (locale === "zh_cn") return zh_cn_event_state_coming_soon(inputs)
	return zh_tw_event_state_coming_soon(inputs)
});